import { render, staticRenderFns } from "./AdvisoryForm.vue?vue&type=template&id=63d3c8ec&scoped=true&"
import script from "./AdvisoryForm.vue?vue&type=script&lang=js&"
export * from "./AdvisoryForm.vue?vue&type=script&lang=js&"
import style0 from "./AdvisoryForm.vue?vue&type=style&index=0&id=63d3c8ec&scoped=true&lang=css&"
import style1 from "./AdvisoryForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d3c8ec",
  null
  
)

export default component.exports